import { SelectInput } from "@/components/admin/select-input";
import { ColorSelectInput } from "./ColorSelectInput";
import { STATUS_DOT_CONFIG, PRIORITY_DOT_CONFIG } from "./colorConfig";

type SelectInputProps = React.ComponentProps<typeof SelectInput>;

/** Colored drop-in replacement for `<SelectInput source="status" .../>`. */
export const StatusSelectInput = (props: SelectInputProps) => (
    <ColorSelectInput colorConfig={STATUS_DOT_CONFIG} {...props} />
);

/** Colored drop-in replacement for `<SelectInput source="priority" .../>`. */
export const PrioritySelectInput = (props: SelectInputProps) => (
    <ColorSelectInput colorConfig={PRIORITY_DOT_CONFIG} {...props} />
);
